// Module
var code = "<md-input-container class=\"mn-datepicker-container\">\n    <label></label>\n    <md-datepicker mn-date ng-model-options=\"{updateOn: 'blur'}\" />\n</md-input-container>";
// Exports
module.exports = code;